import { type DocumentConnectorIntegration } from '../../store/documentConnectors/documentConnectors'

export type SelectionMode = 'single-file' | 'multi-file' | 'single-folder' | 'multi-folder' | 'any'

export const ROOT_ANCHOR_ID = '__root__'

export interface FileBrowserItem {
  id: string
  name: string
  type: 'file' | 'folder'
  size?: number
  modifiedAt?: string
  modifiedBy?: string
  itemCount?: number
  integration?: DocumentConnectorIntegration
}

export interface Breadcrumb {
  id: string
  name: string
  integration?: DocumentConnectorIntegration
}

export interface FolderItemsPage {
  items: FileBrowserItem[]
  totalCount?: number | null
  nextCursor?: string | null
}

export interface FolderContents extends FolderItemsPage {
  breadcrumbs: Breadcrumb[]
}
